import { useTranslation } from 'react-i18next';
import { AppBar, Toolbar } from '@mui/material';
import NSLogo from '../../assets/ns_logo.svg';
import './index.css';

export const PlaceholderPage = () => {
  const { t } = useTranslation();

  return (
    <div className="placeholder-container">
      <AppBar position="fixed" sx={{ background: 'rgb(0, 1, 14)' }}>
        <Toolbar>
          <img src={NSLogo} style={{ width: 153, height: 35 }} />
        </Toolbar>
      </AppBar>
      <p>{t('placeholderPage.message')}</p>
    </div>
  );
};

export default PlaceholderPage;
